import BaseModule from '../../../common/BaseModule.js';

export default {  
    mixins: [BaseModule],  
    data () {
		return {
		}
    },
    methods: {
        findLicenseSKU(licensingInfo, itemType, licenseType, licensePlan, licenseClass) {		
            for (let i = 0; i < licensingInfo.licenses.length; i++) {
                const lic = licensingInfo.licenses[i];

                if (lic.itemType === itemType &&
                    lic.licenseType === licenseType && 
                    lic.licensePlan === licensePlan &&
                    lic.licenseClass === licenseClass) {
                    return lic;
                }
            }
            
            return null;
        },	
        findStockSKU(licensingInfo, itemType, licenseType, licensePlan, licenseClass) {			
            for (let i = 0; i < licensingInfo.stock.length; i++) {
                const lic = licensingInfo.stock[i];
                
                if (lic.itemType === itemType &&
                    lic.licenseType === licenseType && 
                    lic.licensePlan === licensePlan &&
                    lic.itemClass === licenseClass) {
                    return lic;
                }
            }
            
            return null;
        },	
        createLicenseFromSKU(sku, companyId, quantity) {
            return {
                companyId,
                itemType: sku.itemType,
                licenseSKU: sku.id,
                quantity,
                paidAmount: quantity * sku.price
            };
        },	
        createStockFromSKU(sku, companyId, quantity) {
            return {
                companyId,
                itemType: sku.itemType,
                stockSKU: sku.id,
                quantity,
                paidAmount: quantity * sku.price
            };
        },
        calculatePlanEmployees(company) {
            console.log(`*** calculatePlanEmployees...`);

            const numEmployees = Math.max(company.currentSeats, company.currentSeatLimit);

            // Valor mínimo  
            const minEmployees = Math.max(company.currentSeats, company.currentSeatLimit);

            //this.$emit('employees-changed', numEmployees);

            return { num: numEmployees, min: minEmployees };
        },
        // eslint-disable-next-line no-unused-vars
        calculatePlanStorage(company, licensingInfo, licenseType, licensePlan) {
            console.log(`*** calculatePlanStorage...`);
            
            let numStorage = Math.floor(company.currentStorageLimit);

            const license = this.findLicenseSKU(licensingInfo, this.constants.STORAGE_MB, licenseType, licensePlan, this.constants.LICENSE_CLASS_BASE);
    
            let storage = numStorage;
    
            if (license && license.quantity > storage) {
                storage = license.quantity;
            }
    
            numStorage = storage;
    
            // Valor mínimo
            storage = company.currentStorageLimit;
    
            if (license && license.quantity > storage) {
                storage = license.quantity;
            }
    
            // Valor mínimo 
            const minStorage = storage;

            //this.$emit('storage-changed', this.numStorage);

            return { num: numStorage, min: minStorage };
        },
        // eslint-disable-next-line no-unused-vars
        calculatePlanSignatures(company, licensingInfo, licenseType, licensePlan, numSignatures) {
            console.log(`*** calculatePlanSignatures...`);
            
            const item = this.findStockSKU(licensingInfo, this.constants.SMS_SIGNATURE, licenseType, licensePlan, this.constants.LICENSE_CLASS_BASE);

            let signatures = numSignatures;

            if (item && item.quantity > signatures) {
                signatures = item.quantity;
            }

            numSignatures = signatures;
            
            // Valor mínimo    
            const minSignatures = item.quantity;

            //this.$emit('signatures-changed', numSignatures);

            return { num: numSignatures, min: minSignatures };
        }
    }
}